/* eslint-disable @typescript-eslint/ban-ts-comment */
/**
 * Bundler-friendly replacement for `@railzai/railz-visualizations/dist/loader`.
 *
 * The default Stencil lazy loader dynamically imports `*.entry.js` chunks at
 * runtime (e.g. `railz-bank-accounts_8.entry.js`). Webpack understood the
 * `webpackMode: "lazy"` magic comments and emitted those chunks, but Vite /
 * Rollup do not, so the browser requests files that were never built. The dev
 * server / SPA fallback then returns `index.html`, which triggers:
 *   - "Failed to load module script: ... MIME type of 'text/html'"
 *   - "Failed to fetch dynamically imported module: .../*.entry.js"
 *   - "Cannot read properties of undefined (reading 'isProxied')"
 *
 * The `dist/components` (dist-custom-elements) build statically imports all
 * component code, so the bundler includes everything up front and there are no
 * runtime `.entry.js` fetches. We register every component here and expose the
 * same `defineCustomElements` API the React wrapper expects.
 */

// @ts-ignore - Stencil custom-elements build ships its own type declarations
import { defineCustomElement as defineRailzBankAccounts } from '@railzai/railz-visualizations/dist/components/railz-bank-accounts';
// @ts-ignore
import { defineCustomElement as defineRailzBankReconciliation } from '@railzai/railz-visualizations/dist/components/railz-bank-reconciliation';
// @ts-ignore
import { defineCustomElement as defineRailzBusinessValuations } from '@railzai/railz-visualizations/dist/components/railz-business-valuations';
// @ts-ignore
import { defineCustomElement as defineRailzCreditScore } from '@railzai/railz-visualizations/dist/components/railz-credit-score';
// @ts-ignore
import { defineCustomElement as defineRailzErrorImage } from '@railzai/railz-visualizations/dist/components/railz-error-image';
// @ts-ignore
import { defineCustomElement as defineRailzFinancialRatios } from '@railzai/railz-visualizations/dist/components/railz-financial-ratios';
// @ts-ignore
import { defineCustomElement as defineRailzGaugeChart } from '@railzai/railz-visualizations/dist/components/railz-gauge-chart';
// @ts-ignore
import { defineCustomElement as defineRailzIncomeStatements } from '@railzai/railz-visualizations/dist/components/railz-income-statements';
// @ts-ignore
import { defineCustomElement as defineRailzLoading } from '@railzai/railz-visualizations/dist/components/railz-loading';
// @ts-ignore
import { defineCustomElement as defineRailzPercentage } from '@railzai/railz-visualizations/dist/components/railz-percentage';
// @ts-ignore
import { defineCustomElement as defineRailzProgressBar } from '@railzai/railz-visualizations/dist/components/railz-progress-bar';
// @ts-ignore
import { defineCustomElement as defineRailzSelect } from '@railzai/railz-visualizations/dist/components/railz-select';
// @ts-ignore
import { defineCustomElement as defineRailzSparklineChart } from '@railzai/railz-visualizations/dist/components/railz-sparkline-chart';
// @ts-ignore
import { defineCustomElement as defineRailzStatementsChart } from '@railzai/railz-visualizations/dist/components/railz-statements-chart';
// @ts-ignore
import { defineCustomElement as defineRailzTaxBenchmarking } from '@railzai/railz-visualizations/dist/components/railz-tax-benchmarking';
// @ts-ignore
import { defineCustomElement as defineRailzTooltip } from '@railzai/railz-visualizations/dist/components/railz-tooltip';
// @ts-ignore
import { defineCustomElement as defineRailzTransactionsControl } from '@railzai/railz-visualizations/dist/components/railz-transactions-control';
// @ts-ignore
import { defineCustomElement as defineRailzVisualizations } from '@railzai/railz-visualizations/dist/components/railz-visualizations';

const definitions: Array<() => void> = [
  defineRailzBankAccounts,
  defineRailzBankReconciliation,
  defineRailzBusinessValuations,
  defineRailzCreditScore,
  defineRailzErrorImage,
  defineRailzFinancialRatios,
  defineRailzGaugeChart,
  defineRailzIncomeStatements,
  defineRailzLoading,
  defineRailzPercentage,
  defineRailzProgressBar,
  defineRailzSelect,
  defineRailzSparklineChart,
  defineRailzStatementsChart,
  defineRailzTaxBenchmarking,
  defineRailzTooltip,
  defineRailzTransactionsControl,
  defineRailzVisualizations,
];

export const defineCustomElements = (): void => {
  if (typeof window === 'undefined' || typeof customElements === 'undefined') return;
  definitions.forEach((define) => {
    try {
      define();
    } catch {
      // Ignore "already defined" errors from repeated registration.
    }
  });
};

export const applyPolyfills = (): Promise<void> => Promise.resolve();
